import { render, staticRenderFns } from "./jianyi.vue?vue&type=template&id=733f5a9d&scoped=true&"
import script from "./jianyi.vue?vue&type=script&lang=js&"
export * from "./jianyi.vue?vue&type=script&lang=js&"
import style0 from "./jianyi.vue?vue&type=style&index=0&id=733f5a9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733f5a9d",
  null
  
)

export default component.exports